<script setup lang="ts" name="TimelineCharBarExpanded">
import type { ITimelineChartBaseBarDetails } from '~/types';

defineProps<{
  leftOffset: number;
  width: number;
  details: ITimelineChartBaseBarDetails;
}>();
</script>

<template>
  <div
    class="absolute z-30 flex h-full flex-col justify-center gap-1 rounded-md border-b border-l-[5px] border-r border-t border-b-charcoal-4 border-l-ocean-8 border-r-charcoal-4 border-t-charcoal-4 bg-charcoal-1 px-2"
    :style="{
      left: `${leftOffset}px`,
      width: `${width}px`,
    }"
  >
    <p class="truncate text-caption font-bold">{{ details.name }}</p>
    <p
      class="truncate"
      v-title="`${details.name} ${details.status}: ${details.date}`"
    >
      <span class="text-overline text-charcoal-6">{{ details.status }}: </span>
      <span class="ml-2 text-overline">{{ details.date }} </span>
    </p>
  </div>
</template>
